<template>
  <div>
   
    <br />
     <Menu></Menu>
     <div class="grid-responsive">
          <h1 class="title">Usuários</h1>
 
          <Usuario ref="Usuario" v-on:usuarios="usuarios"  />
          <br />      <br />          
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>                   
                  <th>Nome</th>
                  <th>login</th>
                  <th>Email</th>                  
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">                   
                  <td>{{item.nomeUsuario}}</td>
                  <td>{{item.login}}</td>
                  <td>{{item.email}}</td>                  
                   
                  <td class="text-right td-responsive">
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      style="margin-right: 20px;"
                      @click="visualizarUsuario(item.idUsuario)"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button type="button" class="btn btn-outline-danger" @click="deletarUsuario(item.idUsuario)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
   
</template>

<style scoped>
tfoot {
  background-color: #fff;
}
#buttonActions {
  margin-top: 30px;
}
</style>

<script>

import moment from 'moment'

import Menu from "@/components/MenuParceiro.vue";
import Usuario from './Usuario'

import {ParceiroService} from "@/http"


export default {
  name: "usuariosParceiro",
  components: {
    Menu,  
    Usuario
  },
  data: () => {
    return {
      items:[],  
      showModal: false, 
      idUsuario: 0, 
    };
  },
  methods: {
  
    visualizarUsuario(idUsuario) {
          
        this.$refs["Usuario"].visualizarUsuario(idUsuario)

    },
    usuarios(){

      ParceiroService.Usuarios().then(response=>{

         this.items = response.data.map(item =>{

              item.timezoneParceiro = moment(item.timezoneParceiro).utc().locale("pt-br").format("LLL")               
              return item
            })      

      }).catch(error=>{
          window.console.error(error.response)
      })

    }, 
    deletarUsuario(idUsuario){

       if(!confirm("Deseja deletar?")){
          return false
       }

       ParceiroService.DeletarUsuario(idUsuario).then(response=>{

        window.console.warn(response.statusText)
        this.$notify({ group:"notify", text: "Deletado com sucessso",  type:"success", });
        this.usuarios()


      }).catch(error=>{
          window.console.error(error.response)
      })

    }
     
  },
  created() {
    this.usuarios()
   
  }, 
  watch:{
    //searchServicos: _.debounce(function(text) { this.handlerServicos(text) }, 500),  
  }
};
</script>
 
